window.bundleapp = window.bundleapp || {};
window.bundleapp.settings = Object.assign({}, window.bundleapp.settings || {}, {
  bab: {
    productImage: 600
  }
});

const isCustomerPortal = window.location.pathname.includes("/tools/bundle-subscriptions") && window.location.search.includes("subscriptionId=");
const isBaBPurchaseFlow = window.location.pathname.includes("/tools/bundle-subscriptions/bundle/");

const waitForElement = (selector, callback, delay = 0, failsafeDelay) => {
  const observer = new MutationObserver((mutations, obs) => {
    const element = document.querySelector(selector);
    if (element) {
      obs.disconnect();
      if (typeof callback === "function") {
        setTimeout(() => {
          callback(element);
        }, delay);
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  if (failsafeDelay) setTimeout(() => observer.disconnect(), failsafeDelay);
};

/*
  TEMP: AWTOMATIC/BUNDLEAPP ARIA HOTFIX
  Purpose: Sanitize/repair aria-describedby and add accessible names for
  the subscription plan UI injected by the Awtomatic app. Remove this block
  when the upstream app ships their accessibility patch.
*/
(function () {
  function sanitizeDescribedBy(root) {
    var nodes = root.querySelectorAll('[aria-describedby]');
    nodes.forEach(function (el) {
      var raw = el.getAttribute('aria-describedby');
      if (!raw) return;
      var tokens = raw.trim().split(/\s+/);
      var valid = [];
      var hadInvalid = false;
      tokens.forEach(function (tok) {
        if (!tok) return;
        var syntaxOK = /^[A-Za-z][A-Za-z0-9_.:-]*$/.test(tok);
        var exists = syntaxOK && document.getElementById(tok);
        if (syntaxOK && exists) {
          valid.push(tok);
        } else {
          hadInvalid = true;
        }
      });
      if (valid.length) {
        el.setAttribute('aria-describedby', valid.join(' '));
      }
      if (!valid.length && hadInvalid) {
        // Remove broken reference and provide a safe fallback name
        el.removeAttribute('aria-describedby');
        if (!el.hasAttribute('aria-label') && !el.hasAttribute('aria-labelledby')) {
          var label = el.closest('label');
          if (!label && el.id) label = root.querySelector('label[for="' + el.id + '"]');
          var txt = (label ? label.textContent : (el.getAttribute('placeholder') || el.getAttribute('name') || 'Selection')) || 'Selection';
          el.setAttribute('aria-label', txt.toString().trim());
        }
      }
    });
  }

  function labelPlanRadios(root) {
    root.querySelectorAll('.bundleapp-plan-selector-group label').forEach(function (lbl) {
      var input = lbl.querySelector('input[type="radio"]');
      if (!input) return;
      if (!input.hasAttribute('aria-label') && !input.hasAttribute('aria-labelledby')) {
        // Combine label text + pricing text
        var text = Array.from(lbl.childNodes)
          .map(function (n) {
            return n.nodeType === 3 ? n.nodeValue : (n.textContent || '');
          })
          .join(' ')
          .replace(/\s+/g, ' ')
          .trim();
        if (text) input.setAttribute('aria-label', text);
      }
    });
  }

  function labelFrequencyControls(root) {
    root.querySelectorAll('.bundleapp-plan-selector-plan').forEach(function (plan) {
      var lbl = plan.querySelector('label[data-test^="prefixFromSellingPlanGroup-"]');
      var sel = plan.querySelector('select.bundleapp-plan-selector-select');
      if (sel && !sel.hasAttribute('aria-label') && !sel.hasAttribute('aria-labelledby')) {
        if (lbl) {
          if (!lbl.id) {
            // Reuse plan container id when present for stable id
            var base = plan.id || 'awt-plan-' + Math.random().toString(36).slice(2);
            lbl.id = base + '-label';
          }
          sel.setAttribute('aria-labelledby', lbl.id);
        } else {
          sel.setAttribute('aria-label', 'Delivery frequency');
        }
      }

      // Individual radio options
      plan.querySelectorAll('.bundleapp-plan-selector-radio__input').forEach(function (radio) {
        if (!radio.hasAttribute('aria-label') && !radio.hasAttribute('aria-labelledby')) {
          var forLbl = plan.querySelector('label[for="' + radio.id + '"]');
          var t = forLbl ? forLbl.textContent.trim() : 'Option';
          radio.setAttribute('aria-label', t);
        }
      });
    });
  }

  function patchAwtomatic(root) {
    labelPlanRadios(root);
    labelFrequencyControls(root);
    sanitizeDescribedBy(root);
  }

  function start(root) {
    patchAwtomatic(root);
    // Keep patching if the app re-renders
    var mo = new MutationObserver(function () {
      patchAwtomatic(root);
    });
    mo.observe(root, { childList: true, subtree: true });
  }

  var kick = function () {
    document.querySelectorAll('.bundleapp-wrapper, .awt-style-1').forEach(function (el) {
      start(el);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', kick);
  } else {
    kick();
  }

  if (typeof waitForElement === 'function') {
    waitForElement('.bundleapp-wrapper', function (el) {
      start(el);
    }, 0, 10000);
  }
})();
